module.exports = __webpack_public_path__ + "static/6-6bcde4ef4fb418d784e82dc13b73b36c.gif";